import React from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const ComputeForm = (props) => {
  const { clusterList = [], cluster, setComputeState } = props;
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          md: 4
        }}>
        <FormControl required fullWidth variant="outlined" sx={{ my: 2 }}>
          <InputLabel>Compute Cluster</InputLabel>
          <Select
            value={cluster}
            onChange={(e) => setComputeState(e.target.value)}
            label="Compute Cluster"
            MenuProps={{ sx: { height: "220px" } }}
          >
            {(clusterList || [])?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

ComputeForm.propTypes = {
  clusterList: PropTypes.array.isRequired,
  cluster: PropTypes.string.isRequired,
  setComputeState: PropTypes.func.isRequired,
};

export default React.memo(ComputeForm);
